import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';
import { t } from '../../../app/i18n';
import { ResponsiveTable } from '../../../common/components/data-display';
import { formatDateTime } from '../../../common/utils/helpers';
import { messageStatus, messageStatusT } from '../../../common/enums'


const Column = Table.Column;


const statusFunction = (status) => {
  return {
    children: <span>{messageStatusT[messageStatus[status]]}</span>,
  };
};

const sentDateFunction = (sentDate) => {
  return {
    children: <span>{sentDate ? `${formatDateTime(sentDate)}` : ``}</span>,
  };
};
const nameFunction = (receiverName) => {
  return {
    children: <span>{`${receiverName}`}</span>,
  };
};
const receiverFunction = (receiver) => {
  return {
    children: <span>{`${receiver}`}</span>,
  };
};
const subjectFunction = (subject) => {
  return {
    children: <span>{`${subject}`}</span>,
  };
};
const readFunction = (read) => {
  return {
    children: <span>{read ? `${t("Áno")}` : `${t("Nie")}`}</span>,

  };
};



const EmailLogsTable = ({ emailLogs, actions, loading, onChange, pagination, t }) => {

  emailLogs.forEach(item => {
    item.receiverName = item.receiverNameFirst + ' ' + item.receiverNameLast
  })
  return (

    <ResponsiveTable
      dataSource={emailLogs}
      loading={loading}
      onChange={onChange}
      pagination={pagination}
      rowKey={emailLog => emailLog.id}
      rowClassName={emailLog => emailLog.nonpayer ? 'nonpayer-row' : ''}
    >
      <Column
        title={t('Dátum zaslania')}
        dataIndex="sentDate"
        key="sentDate"
        render={(item) => sentDateFunction(item)}
      />
      <Column
        title={t('Stav')}
        dataIndex="status"
        key="status"
        render={(item) => statusFunction(item)}
      />

      <Column
        title={t('Prijímateľ')}
        dataIndex="receiverName"
        key="receiverName"
        render={(item) => nameFunction(item)}
      />
      <Column
        title={t('E-mailová adresa')}
        dataIndex="receiver"
        key="receiver"
        render={(item) => receiverFunction(item)}
      />
      <Column
        title={t('Predmet správy')}
        dataIndex="subject"
        key="subject"
        render={(item) => subjectFunction(item)}
      />
      <Column
        title={t('Správa prečítaná')}
        dataIndex="read"
        key="read"
        render={(item) => readFunction(item)}
      />
      <Column title={t('Akcie')} key="action" render={actions} />
    </ResponsiveTable>
  )
};

EmailLogsTable.propTypes = {
  emailLogs: PropTypes.array.isRequired,
  actions: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

EmailLogsTable.defaultProps = {
  actions: (emailLog) => <Link to={`/admin/messaging/${emailLog.id}`}>{t('Detail')}</Link>,
};

export default translate()(EmailLogsTable);



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/components/EmailLogsTable.js